"use client"

import { useState, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const useFetchProblems = (groupId, refreshKey = 0) => {
  const [problems, setProblems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
    const fetchProblems = async () => {
      if (!groupId) {
        setLoading(false)
        setProblems([])
        return
      }

      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_API_AUDIENCE,
          },
        })

        const response = await fetch(`${apiUrl}/api/Problems?groupId=${groupId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        if (response.ok) {
          const data = await response.json()
          setProblems(data)
          setError(null)
        } else {
          console.error("Failed to fetch problems:", response.statusText)
          setError("Failed to load problems. Please try again later.")
        }
      } catch (error) {
        console.error("Error fetching problems:", error.message)
        setError("Failed to load problems. Please try again later.")
      } finally {
        setLoading(false)
      }
    }

    fetchProblems()
  }, [groupId, getAccessTokenSilently, apiUrl, refreshKey])

  return { problems, loading, error }
}

export default useFetchProblems
